/* eslint-disable jsx-a11y/no-static-element-interactions */
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';

const ProductDescription = ({ sourceName, favIcon, product, description, isLoadingProduct }) => {
  const { t } = useTranslation();
  const [descToggle, setDescToggle] = useState(false);

  // Show skeleton loading during server fetch or data extraction/enhancement
  const isLoading = isLoadingProduct || (product && (product.status === 'EXTRACTING' || product.isEnhancingInProgress));

  if (isLoading) {
    return <SkeletonLoader type='basic' count={4} />;
  }

  return (
    <>
      <p className='mb-2 mb-md-8'>{product.createdAt ? moment(product.createdAt).format('DD.MM.YY') : '-'}</p>
      <div className='d-flex align-items-center justify-content-between mb-4 mb-md-10'>
        <div className='d-flex align-items-center'>
          <img width={30} height={30} className='mr-3 mr-md-8' src={favIcon || ''} alt='logo' />
          <p className='text-md text-lg-lg mb-0 fw-300 text-capitalize'>{sourceName || '-'}</p>
        </div>
        {product.item?.brand && (
          <div>
            <p className='mb-0 text-sm text-md-lg'>
              <b>{t('label_brand')}</b>: {product.item.brand}
            </p>
          </div>
        )}
      </div>
      <div className='pr-desc'>
        <p className='text-md text-lg-lg fw-500 mb-2 mb-md-6'>{t('title_about')}</p>
        <p className={`${descToggle ? '' : 'text-line-3'} mb-0 text-sm text-md-lg`}>{description || '-'}</p>
        {description && (
          <span
            className='fw-500 cursor-pointer mt-1 mt-md-2 d-flex text-primary'
            onClick={() => setDescToggle(!descToggle)}
          >
            {descToggle ? t('text_read_less') : t('text_read_more')}
          </span>
        )}
      </div>
    </>
  );
};

export default ProductDescription;
